/** Schedule non-visible work without letting it disappear forever on a busy page. */
export function scheduleIdle(
  task: () => void,
  {
    timeout = 4_000,
    fallbackDelay = 1_500,
  }: { timeout?: number; fallbackDelay?: number } = {},
): () => void {
  let cancelled = false;
  const run = () => {
    if (!cancelled) task();
  };

  const requestIdle = window.requestIdleCallback?.bind(window);
  if (requestIdle) {
    const id = requestIdle(run, { timeout });
    return () => {
      cancelled = true;
      window.cancelIdleCallback?.(id);
    };
  }

  const id = window.setTimeout(run, fallbackDelay);
  return () => {
    cancelled = true;
    window.clearTimeout(id);
  };
}
